import React, { useEffect, useRef, useState } from 'react';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ButtonLoader } from "components/__new/common/form";
import { ReactComponent as Envelopes } from "assets/images/icons/project-icons/envelopes.svg"
import PinInput from 'react-pin-input';
import Maybe from 'components/__new/common/Maybe';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { requestNewUserOtp, verifyNewUserOtp } from 'store/auth/user/action';



export const VerifyEmail = () => {
    // eslint-disable-next-line
    let elementRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const { newUserOtpLoading, newUserDetails, verifyNewUserOtpLoading, verifyNewUserOtpData, createNewUserLoading } = useSelector((s) => s.auth.user);

    
    const [otp, setOtp] = useState("");
    const [timerShown, setTimerShown] = useState(true);
    
    
    const onSubmit = async () => {
        dispatch(verifyNewUserOtp({
            email: newUserDetails.email,
            otp
        }))
    }
    
    const resendOtp = () => {
        dispatch(requestNewUserOtp({
            email: newUserDetails.email,
            companyName: newUserDetails.businessName,
        })).then(() => setTimerShown(!timerShown));
    }
    
    useEffect(() => {
        if(!newUserDetails?.email?.length || !newUserDetails?.businessName?.length) {
            history.push("/onboarding/get-started")
        }
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if(verifyNewUserOtpData?.status === "success") history.push("/onboarding/create-business-password");
        // eslint-disable-next-line
    }, [verifyNewUserOtpData])
    
    
    return (
        <>

            <DynamicHeadTag
                headerText="Verify Email"
            />
            
            <div className="p-8 w-full">
                <div className="w-full flex items-center justify-center flex-col">
                    <div className="mt-2 mb-10 flex items-center justify-center">
                        <Envelopes /> 
                    </div>
                    
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold">
                            Verify your email
                        </div>
                        <div className="text-[#505666] text-sm mt-3">
                            Enter the OTP sent to {newUserDetails?.email}
                        </div>
                    </div>
                    
                    
                    <div className="mt-8 mb-4 w-full lg:w-3/5 flex items-center justify-center mx-auto">
                        <PinInput
                            length={6} 
                            focus={true}
                            secret={false}
                            autoSelect={true}
                            initialValue={otp}
                            ref={(n) => (elementRef = n)}
                            onComplete={(value, index) => {}}
                            onChange={(value) => setOtp(value)} 
                            inputFocusStyle={{borderBottom: "1px solid #ADB5BD"}}
                            inputStyle={{width: "35px", border: "none", borderBottom: "1px solid #ADB5BD", fontSize: "20px", paddingBottom: "6px"}}
                        />
                    </div>
                    
                    <div className="w-3/4 md:w-2/4 lg:w-1/4">
                        <ButtonLoader loading={verifyNewUserOtpLoading || createNewUserLoading} disabled={otp?.length < 6 || verifyNewUserOtpLoading || createNewUserLoading} onClick={onSubmit} className="btn btn-lg btn-block btn-ep-primary mt-8 disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                            {verifyNewUserOtpLoading || createNewUserLoading ? "Initializing..." : "Submit"}
                        </ButtonLoader>
                    </div>
                    
                    <Maybe condition={newUserOtpLoading}>
                        <div className="text-ep-primary-500 font-medium mt-10">Resending...</div>
                    </Maybe>
                    
                    <Maybe condition={newUserOtpLoading === false && (!verifyNewUserOtpData || verifyNewUserOtpData?.status !== "success")}>
                        <div className="mt-10">
                            <Maybe condition={timerShown === true}>
                                <div className="flex items-center text-[#505666] text-sm">
                                    <div>Resend code in:&nbsp;</div>
                                    <Countdown minutes={2} onExpiry={() => setTimerShown(false)} />
                                </div>
                            </Maybe>
                            
                            <Maybe condition={timerShown === false}>
                                <div className="flex items-center text-[#505666] text-sm">
                                    <div>Didn't receive OTP? &nbsp;</div>
                                    <button onClick={resendOtp} className="text-ep-primary-500 font-medium">Resend OTP</button>
                                </div>
                            </Maybe>
                        </div>
                    </Maybe>
                </div>
            </div>
        </>
    )
}


const Countdown = ({ hours = 0, minutes = 0, seconds = 0, onExpiry }) => {
    
    const [time, setTime] = useState({
        hours: parseInt(hours),
        minutes: parseInt(minutes),
        seconds: parseInt(seconds),
    });
    
    
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            if (time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
            clearInterval(countdownInterval);
            onExpiry();
            } else {
            if (time.seconds > 0) {
                setTime(prevTime => ({ ...prevTime, seconds: prevTime.seconds - 1 }));
            } else {
                if (time.minutes > 0) {
                setTime(prevTime => ({
                    ...prevTime,
                    minutes: prevTime.minutes - 1,
                    seconds: 59,
                }));
                } else {
                if (time.hours > 0) {
                    setTime(prevTime => ({
                    ...prevTime,
                    hours: prevTime.hours - 1,
                    minutes: 59,
                    seconds: 59,
                    }));
                }
                }
            }
            }
        }, 1000);
        
        
        return () => clearInterval(countdownInterval);
        // eslint-disable-next-line
    }, [time]);
    
    
    return (
        <span>{`${time.minutes.toString().padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`}</span>
    );
};


export default VerifyEmail;